/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TWebGetFolderOffersByRealtyOfferIdModel,
  IWebGetFolderOffersByRealtyOfferIdRequest,
  IMappers,
  IWebGetFolderOffersByRealtyOfferIdResponse,
  IWebGetFolderOffersByRealtyOfferIdResponseError,
  TWebGetFolderOffersByRealtyOfferIdResponse,
} from './types';

const defaultConfig: TWebGetFolderOffersByRealtyOfferIdModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'favorites',
  pathApi: '/v1/web/get-folder-offers-by-realty-offer-id/',
  hostType: 'api',
} as TWebGetFolderOffersByRealtyOfferIdModel;

function createWebGetFolderOffersByRealtyOfferIdModel(
  parameters: IWebGetFolderOffersByRealtyOfferIdRequest,
): TWebGetFolderOffersByRealtyOfferIdModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IWebGetFolderOffersByRealtyOfferIdOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IWebGetFolderOffersByRealtyOfferIdRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchWebGetFolderOffersByRealtyOfferId<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IWebGetFolderOffersByRealtyOfferIdOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TWebGetFolderOffersByRealtyOfferIdResponse
> {
  const { response, statusCode } = await httpApi.fetch(
    createWebGetFolderOffersByRealtyOfferIdModel(parameters),
    config,
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IWebGetFolderOffersByRealtyOfferIdResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IWebGetFolderOffersByRealtyOfferIdResponseError);
    }
  }

  return { response, statusCode } as TWebGetFolderOffersByRealtyOfferIdResponse;
}

export { defaultConfig, createWebGetFolderOffersByRealtyOfferIdModel, fetchWebGetFolderOffersByRealtyOfferId };
